import { render } from "./AppDashboard.vue?vue&type=template&id=0baae8dd&scoped=true"
import script from "./AppDashboard.vue?vue&type=script&lang=js"
export * from "./AppDashboard.vue?vue&type=script&lang=js"

import "./AppDashboard.vue?vue&type=style&index=0&id=0baae8dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baae8dd"]])

export default __exports__